"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_c0c0a405{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_c0c0a405{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_c0c0a405{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n" }]);
exports.root = "root_c0c0a405";
exports.rootVertical = "rootVertical_c0c0a405";
exports.item = "item_c0c0a405";
//# sourceMappingURL=OverflowSet.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/OverflowSet/OverflowSet.scss.js
// module id = 1611
// module chunks = 0